module.exports = __webpack_public_path__ + "img/the-netherlands-tuberculosis-female.ff90e899.png";